import React from 'react'
import ProjectsList from './ProjectsList'
import TeamMembers from './TeamMembers'

export default function Sidebar() {
    return (
        <aside className="sidebar">
            {/* Projects List  */}
            <ProjectsList/>

            {/* Team Members  */}
           <TeamMembers/>
        </aside>
    )
}
